import request from '@/front/shared/utils/request';

export const primaryKey = 'id';

export function list(sessionId = null, team = false) {
    return request({
        url: `/collaboration-roles`,
        method: 'get',
        params: {
            session_id: sessionId,
            team,
        },
    });
}

export function remove(id) {
    return request({
        url: `/collaboration-roles/${id}`,
        method: 'delete',
    });
}

export function show(id) {
    return get(id);
}

export function get(id) {
    return request({
        url: `/collaboration-roles/${id}`,
        method: 'get',
    });
}

/*export function update(id, data) {
    return request({
        url: `/collaboration-roles/${ id }`,
        method: 'put',
        data,
    });
}*/

export function store(data) {
    return request({
        url: `/collaboration-roles`,
        method: 'post',
        data,
    });
}

/*
export function save(data) {
    if (data.hasOwnProperty(primaryKey) && data[primaryKey] != null) {
        return update(data[primaryKey], data);
    }

    return store(data);
}
*/
